import script from "./DecorationTechnique.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecorationTechnique.vue?vue&type=script&setup=true&lang=ts"

import "./DecorationTechnique.vue?vue&type=style&index=0&id=0c4aa2b6&lang=css"

const __exports__ = script;

export default __exports__